module.exports = __webpack_public_path__ + "img/katarina_living_room_7.98523214.jpg";